import cn from 'classnames'
import type { FC } from 'react'

import { HeaderBlockContextProvider } from './context'
import css from './HeaderBlock.css'
import type { HeaderBlockProps } from './types'

export const HeaderLeftBlock: FC<HeaderBlockProps> = ({ children, className }) => {
  return (
    <span className={cn(css.left, className)}>
      <HeaderBlockContextProvider position="left">{children}</HeaderBlockContextProvider>
    </span>
  )
}
